// extracted by mini-css-extract-plugin
module.exports = {"box":"KPTable_box__1NriT","button":"KPTable_button__2U5yi","stickyColumnHeader":"KPTable_stickyColumnHeader__38k16","stickyColumn":"KPTable_stickyColumn__18VUf"};